






































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Icon, { IconEnum } from '@/shared/components/icon.component.vue';
import SwitchButton from '@/shared/components/switch.component.vue';

@Component({
  components: {
    Icon,
    SwitchButton,
  },
})
export default class ExpansionPanel extends Vue {
  @Prop({ default: '' }) readonly headerText!: string;
  @Prop({ default: null }) readonly switchBtn!: boolean;
  @Prop({ default: '' }) readonly headerColor!: string;
  // Expansion Panel state:boolean true if is open | false if is closed
  @Prop({ default: false }) readonly state!: boolean;
  @Prop({ default: false }) readonly disabled!: boolean;
  @Prop({ default: true }) readonly headerArrow!: boolean;
  @Prop({ default: false }) readonly summaryHover!: boolean;

  private iconEnum = IconEnum;
  private animating = false;

  @Watch('state')
  private watchState(newVal: boolean, oldVal: boolean) {
    if (newVal !== oldVal) {
      this.handleState(newVal);
    }
  }

  mounted() {
    if (this.state) {
      this.handleState(false);
    }
  }

  private get hasSwitchBtn() {
    return this.switchBtn !== null ? 'summary--has-switch' : '';
  }

  get syncState() {
    return this.state;
  }

  private handleClick() {
    if (!this.disabled) {
      this.handleState();
    }
  }

  get headerPanelSlot() {
    return !!this.$slots['panel-header'];
  }

  set syncState(value) {
    this.$emit('update:state', value);
  }

  get switchBtnValue() {
    return this.switchBtn;
  }
  set switchBtnValue(value) {
    this.$emit('update:switchBtn', value);
  }

  private handleState(state?: boolean) {
    if (this.animating) {
      return;
    }
    this.animating = true;
    const panel = this.$refs['panel-item'] as HTMLDivElement;
    const panelWrapper = panel.lastChild as HTMLDivElement;
    const content = panelWrapper.firstChild as HTMLDivElement;

    let isOpen: boolean;
    let delay = 0;
    if (typeof state === 'boolean') {
      isOpen = !state;
      delay = 20;
    } else {
      this.$emit('panel-header-click', true);
      isOpen = panel.classList.contains('panel-item--open');
    }
    this.syncState = !isOpen;

    if (isOpen) {
      panelWrapper.style.height = content.clientHeight + 'px';
      panelWrapper.style.overflow = 'hidden';
      setTimeout(() => {
        panelWrapper.style.height = '0px';
        this.animating = false;
      }, delay);
    } else {
      panelWrapper.style.height = content.clientHeight + 'px';
      setTimeout(() => {
        panelWrapper.style.height = 'auto';
        panelWrapper.style.overflow = 'visible';
        this.animating = false;
      }, 200);
    }
    panel.classList.toggle('panel-item--open');
  }
}
